import React from 'react';
import styled from 'styled-components';
import { preloader } from '../img';
import { Tap } from '../dooh-react-utils';

export default function Intro(props) {
  return (
    <Wrap onTap={props.gotoNextScreen}>
      {/*
      <img
        className="hand"
        src={preloader.get(require('../img/hand.png'))}
        alt=""
      />
      */}
    </Wrap>
  );
}

const Wrap = styled(Tap)`
  background: url('${() =>
    preloader.get(require('../img/cta.png'))}') no-repeat 0 0;
  position: absolute;
  top: 0;

  @keyframes pulse_animation {
    0% {
      transform: rotate(-15deg) scale(0.3);
    }
    50% {
      transform: rotate(-15deg) scale(0.35);
    }
    100% {
      transform: rotate(-15deg) scale(0.3);
    }
  }

  .hand {
    position: absolute;
    bottom: 0px;
    right: 200px;
    animation-name: pulse_animation;
    animation-duration: 1.5s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }
`;
